import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[editable]'
})
export class EditableDirective {
  @Input() editable:boolean = true
  constructor(private el: ElementRef) {  }
  @HostListener('mouseenter') onMouseEnter() {
    this.edit(this.editable || false);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.edit(false);
  }
  edit(edit:boolean){
  	this.el.nativeElement.contentEditable = this.editable
  }
}



// WEBPACK FOOTER //
// ./src/app/editable.directive.ts